import { apiInstance } from "../utils/_apiInstance";

interface SaveDocumentBody {
  documentoId: string;
  id: string;
  tipo: string;
  url: string;
}

export const postSaveDocument = async (document: SaveDocumentBody) => {
  const response = await apiInstance.post("/documentos", document);
  return response.data.result;
};
